module.exports = __webpack_public_path__ + "img/hangye.23a910ee.jpg";